import { isNil } from 'lodash';
import isEmail from 'validator/lib/isEmail';
import isUUID from 'validator/lib/isUUID';
const isNumericValueRegExp = new RegExp(/^-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?$/);
export const isPhoneNumber = ({ t }) => (value) => {
    const phoneRegex = new RegExp(/(?:(\+\d{1,4}))?[\d ()\-.]{5,}$/);
    return value && !phoneRegex.test(value) ? t('common:validators:format:phone_number') : undefined;
};
export const isValidEmail = ({ t }) => (value) => value && !isEmail(value) ? t('common:validators:format:email') : undefined;
export const isNumeric = ({ t }) => (value) => {
    return isNil(value)
        ? t('common:validators:format:input_not_valid')
        : !isNumericValueRegExp.test(value.toString())
            ? t('common:validators:format:numeric')
            : undefined;
};
export const isLettersOnly = ({ t }) => (value) => {
    const lettersOnlyRegex = new RegExp(/^([A-zÀ-ú']+\s)*[A-zÀ-ú']+$/);
    return isNil(value) || !lettersOnlyRegex.test(value) ? t('common:validators:format:text_only') : undefined;
};
export const isValidUUID = ({ t }) => (value) => value && !isUUID(value) ? t('common:validators:format:uuid') : undefined;
//# sourceMappingURL=validation.format.js.map